

import { mapGetters } from 'vuex'

export default {
  name: 'EnerRank',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    order: {
      type: String,
      default: 'top',
      validator: value => ['bottom', 'top'].includes(value)
    },
    itemNumber: {
      type: Number,
      default: 10
    },
    valueMin: {
      type: Number,
      default: 0
    },
    valueMax: {
      type: Number,
      default: null
    },
    valueField: {
      type: String,
      default: 'value'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    nbDecimal: {
      type: Number,
      default: 2
    },
    barHeights: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      countries: 'countries',
      currentYear: 'page/currentYear'
    }),
    rankedItems () {
      return [...this.items].sort((a, b) => {
        if (this.order === 'bottom') {
          return a.value - b.value
        } else {
          return b.value - a.value
        }
      }).slice(0, this.itemNumber)
    },
    max () {
      if (this.valueMax !== null) {
        return this.valueMax
      } else {
        return Math.max.apply(Math, this.rankedItems.map(o => Math.abs(o.value)))
      }
    },
    min () {
      const min = Math.min.apply(Math, this.rankedItems.map(o => o.value))
      return min - (Math.abs(this.max - min) * 0.1)
    },
    maxBarValue () {
      let maxBarValue = 0
      const max = Math.max.apply(Math, this.rankedItems.map(o => o.value))
      const min = this.min
      maxBarValue = (max < 0) ? (max + Math.abs(min)) : (max - min)
      return maxBarValue
    },
    displayedItems () {
      const max = Math.max.apply(Math, this.rankedItems.map(o => o.value))
      const min = this.min
      const displayedItems = []
      this.rankedItems.forEach(function (item) {
        item.barValue = (max < 0) ? (item.value + Math.abs(min)) : (item.value - min)
        displayedItems.push(item)
      })
      return displayedItems
    }
  },
  methods: {
    barHeightStyle (index) {
      if (this.barHeights.length >= this.items.length) {
        return {
          height: this.barHeights[index] + 'px'
        }
      }
      return null
    },
    handleClick (item) {
      this.$emit('click', item)
    }
  }
}
